import create from 'zustand';
import {UserTokenInterface} from "../interface/UserTokenInterface";
import {User} from "../interface/security/user";

interface SessionStore {
    data?: User | null;
    setData: (data: User | null | undefined) => void;
    user?: UserTokenInterface | null;
    setUser: (data: any | null | undefined) => void;
}

export const useSessionStore = create<SessionStore>((set) => ({
    data: null,
    setData: (data: any) => set({ data }),
    user: null,
    setUser: (user: UserTokenInterface) => set({ user }),
}));
